function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  stroke: "#C1A36E",
  viewBox: "0 0 22.857 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.857 6.847H20m-12.381.001V4.943a1.905 1.905 0 0 1 1.904-1.905h3.81a1.905 1.905 0 0 1 1.904 1.905v1.905m2.857 0V20.18a1.904 1.904 0 0 1-1.904 1.905H6.666a1.905 1.905 0 0 1-1.904-1.905V6.848h13.332Z",
  style: {
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}));
SvgTrash.viewBox = '0 0 22.857 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;